import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {Comment} from "../api";

export class CommentService extends RestService<Comment> {
    constructor(url?: string) {
        url ? super(url) : super(REST_API_END_POINTS.COMMENTS)
    }
}
